import { render, staticRenderFns } from "./ShiftAddForm.vue?vue&type=template&id=31e46a87&scoped=true&"
import script from "./ShiftAddForm.vue?vue&type=script&lang=js&"
export * from "./ShiftAddForm.vue?vue&type=script&lang=js&"
import style0 from "./ShiftAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShiftAddForm.vue?vue&type=style&index=1&id=31e46a87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e46a87",
  null
  
)

export default component.exports